import * as React from 'react';
import {createSelector} from 'reselect';
import * as _ from 'lodash';
import {unflatten} from 'flat';
import CachedIcon from 'material-ui/svg-icons/action/cached';
import {AMAZON_LISTINGS_ACTIONS_TYPES} from '../ActionsTypes';
import {ACTION_DISPLAY_TYPES, BaseActionsProps, ActionProps} from '../ActionsManagerConsts';
import {syncSellerListings} from './AmazonListingsActionsHelpers';
import {getCurrentState} from '../EbayListingsActions/currentState';
import {createNewListings} from './AmazonListingsActionsHelpers';
import {getUpdatedData, getValidData} from 'cl-table/redux/selectors';
import {store} from '../../../App/store';
import {deleteTable} from 'cl-table/redux/actions';
import routes from '../../../App/routeConstants';
import {browserHistory} from 'react-router';
import {AmazonListing, Tables} from 'cl-api';
import {getAmazonSellerId} from '../../../MyAccount/AmazonListings/amazonListingHelpers';

export interface AmazonListingsActionsProps extends BaseActionsProps {
  types: Array<AMAZON_LISTINGS_ACTIONS_TYPES>;
  objects?: AmazonListing[];
}

// TODO - write this part better after skippy that works generically on tasks

const getAmazonSyncDone = state => _.get(state.general.progress[Tables.AmazonListingsTable], 'done', true);

const isAmazonSyncComplete = createSelector(
  [getAmazonSyncDone],
  amazonSyncDone => {
    return {amazonListingsSyncComplete: amazonSyncDone};
  }
);

export const AMAZON_LISTINGS_ACTIONS_PROPS: {[actionType: string]: ActionProps<AmazonListing>} = {
  [AMAZON_LISTINGS_ACTIONS_TYPES.REFRESH]: {
    getStoreProps: isAmazonSyncComplete,
    isDisabled: (objects, {amazonListingsSyncComplete}) => !amazonListingsSyncComplete,
    shouldRender: _.constant(true),
    action: () => {
      return () => {
        const state = getCurrentState();
        const sellerId = getAmazonSellerId(state);
        syncSellerListings(sellerId);
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: 'Sync From Amazon', icon: <CachedIcon />},
    },
    objectIsOptional: true,
  },
  [AMAZON_LISTINGS_ACTIONS_TYPES.PUBLISH_PRODUCTS_TO_AMAZON]: {
    shouldRender: _.constant(true),
    action: () => {
      return async () => {
        const state = getCurrentState();
        const sellerId = getAmazonSellerId(state);
        const tableState = state.table[Tables.PublishToAmazonTable];
        const site = tableState.initParams.site;
        const allListings = getUpdatedData(tableState);
        const readyListings = getValidData(tableState);
        _.defer(() =>
          window['analytics'].track('Publish to Amazon', {
            'Number of Ready Products': readyListings.count(),
            'Number of Not Ready Products': allListings.count() - readyListings.count(),
          })
        );
        const listings: AmazonListing[] = readyListings
          .map((fieldsToRevise: any) => {
            const listing: AmazonListing = unflatten(
              _.pickBy(fieldsToRevise, (value, index) => index !== '_source' && value !== undefined)
            );
            listing['productId'] = fieldsToRevise._source._id;
            return listing;
          })
          .toList()
          .toArray();
        store.dispatch(deleteTable({name: Tables.PublishToAmazonTable as any}));
        browserHistory.push({pathname: routes.MyAccount.AmazonListings, query: {selectedSellerId: sellerId}});
        return createNewListings({objects: listings, site}, sellerId);
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: 'publish products', color: 'primary'},
    },
    objectIsOptional: true,
  },
};
